import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

import { TechCheckResultRequest } from './types';

export const techCheckApi = createApi({
  reducerPath: 'techCheckApi',
  baseQuery: retry(axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }), { maxRetries: 3 }),
  endpoints: (builder) => ({
    postTechCheckResult: builder.mutation<void, TechCheckResultRequest>({
      query: (data) => ({
        url: `/techcheck`,
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { usePostTechCheckResultMutation } = techCheckApi;
